import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useDateSort } from '../../../../hooks/useDateSort';

const TIME_RANGES = ['00-03', '03-06', '06-09', '09-12', '12-15', '15-18', '18-21', '21-24'] as const;

export type TimeParticipationCell = {
  rate: number;
  count: number;
};

export type TimeParticipationTableRow = {
  date: string;
  intervals: TimeParticipationCell[];
};

const headerCellSx = {
  whiteSpace: 'nowrap' as const,
  borderBottom: '1px solid #e0e0e0',
  backgroundColor: '#fafafa',
  fontSize: '0.75rem',
  py: 0.75,
  px: 0.75,
};

const bodyCellSx = {
  borderBottom: '1px solid #e0e0e0',
  fontSize: '0.7rem',
  py: 0.75,
  px: 0.75,
  verticalAlign: 'top',
};

type Props = {
  rows?: TimeParticipationTableRow[];
};

export default function RouletteContentTimeParticipationTable({ rows }: Props) {
  const tableRows = rows ?? [];
  const { sorted, sortDirection, toggleSort } = useDateSort(tableRows, (r) => r.date, 'desc');

  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderRadius: 3,
        p: 2,
        mt: 2,
        overflow: 'auto',
      }}
    >
      <Typography variant="subtitle2" fontWeight={600} mb={1.5} color="#475569" sx={{ fontSize: '0.9rem' }}>
        상세 현황
      </Typography>
      <TableContainer sx={{ width: '100%' }}>
        <Table size="small" stickyHeader sx={{ borderCollapse: 'collapse', width: '100%' }}>
          <TableHead>
            <TableRow>
              <TableCell
                align="center"
                onClick={toggleSort}
                sx={{
                  ...headerCellSx,
                  minWidth: 72,
                  cursor: 'pointer',
                  userSelect: 'none',
                  '&:hover': { backgroundColor: '#f1f5f9' },
                }}
              >
                날짜 {sortDirection === 'asc' ? '↑' : '↓'}
              </TableCell>
              {TIME_RANGES.map((range) => (
                <TableCell key={range} align="center" sx={headerCellSx}>
                  {range}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {sorted.map((row) => (
              <TableRow key={row.date}>
                <TableCell align="center" sx={bodyCellSx}>
                  {row.date}
                </TableCell>
                {row.intervals.map((cell, i) => (
                  <TableCell key={i} align="center" sx={bodyCellSx}>
                    <Box sx={{ lineHeight: 1.3 }}>
                      <Box
                        component="span"
                        sx={{ display: 'block', fontSize: '0.75rem', fontWeight: 600 }}
                      >
                        {cell.rate}%
                      </Box>
                      <Box
                        component="span"
                        sx={{ display: 'block', fontSize: '0.68rem', color: '#64748b' }}
                      >
                        {cell.count.toLocaleString('ko-KR')}
                      </Box>
                    </Box>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
